import { defineMessage, useIntl } from 'react-intl'

import { getTranslatedValidation } from '@subaio/components/src/HookForm'

import { fieldPhoneNumber, fieldPhoneNumberOptional } from './fieldPhoneNumber'

export const useValidation = () => {
	const { formatMessage } = useIntl()

	const requiredMessage = formatMessage(
		defineMessage({ id: 'inputValidationError.required', defaultMessage: 'This field is required' }),
	)
	const invalidEmailMessage = formatMessage(
		defineMessage({ id: 'inputValidationError.invalidEmail', defaultMessage: 'Has to be a valid email' }),
	)
	const invalidNumberMessage = formatMessage(
		defineMessage({ id: 'inputValidationError.invalidNumber', defaultMessage: 'Has to be a number' }),
	)
	const phoneNumberStartMessage = formatMessage(
		defineMessage({
			id: 'formFields.input.invalidPhoneNumberStart',
			defaultMessage: 'Start your phone number with 0 or +',
		}),
	)
	const phoneNumberDigitsMessage = formatMessage(
		defineMessage({ id: 'formFields.input.invalidPhoneNumberDigits', defaultMessage: 'Enter numbers only' }),
	)

	const translatedStructs = getTranslatedValidation({
		requiredMessage,
		invalidEmailMessage,
		invalidNumberMessage,
	})

	return {
		...translatedStructs,
		fieldPhoneNumber: () =>
			fieldPhoneNumber({
				requiredErrorMessage: requiredMessage,
				startErrorMessage: phoneNumberStartMessage,
				digitsErrorMessage: phoneNumberDigitsMessage,
			}),
		fieldPhoneNumberOptional: () =>
			fieldPhoneNumberOptional({
				startErrorMessage: phoneNumberStartMessage,
				digitsErrorMessage: phoneNumberDigitsMessage,
			}),
	}
}
